"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconShareAndroid = void 0;
var React = __importStar(require("react"));
var IconShareAndroid = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M18.5,17 C17.728,17 17.046,17.357 16.587,17.908 L6.885,12.711 C6.952,12.484 7,12.249 7,12 C7,11.751 6.952,11.516 6.885,11.289 L16.587,6.092 C17.046,6.643 17.728,7 18.5,7 C19.881,7 21,5.881 21,4.5 C21,3.119 19.881,2 18.5,2 C17.119,2 16,3.119 16,4.5 C16,4.749 16.048,4.984 16.115,5.211 L6.413,10.408 C5.954,9.857 5.272,9.5 4.5,9.5 C3.119,9.5 2,10.619 2,12 C2,13.381 3.119,14.5 4.5,14.5 C5.272,14.5 5.954,14.143 6.413,13.592 L16.115,18.789 C16.048,19.016 16,19.251 16,19.5 C16,20.881 17.119,22 18.5,22 C19.881,22 21,20.881 21,19.5 C21,18.119 19.881,17 18.5,17" }))); };
exports.IconShareAndroid = IconShareAndroid;
exports.IconShareAndroid.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconShareAndroid;
